import { ComponentProps, useId } from 'react';
import { Modal as BulmaModal, Element, Icon } from 'react-bulma-components';
import { FaXmark } from 'react-icons/fa6';
import If from '../../shared/if/if';
import Button from '../button/button';
import styles from './modal.module.scss';

export type ModalProps = ComponentProps<typeof BulmaModal> & {
  title: string;
  titleClassName?: string;
  cardClassName?: string;
};

export function Modal({
  title,
  titleClassName,
  children,
  showClose = false,
  closeOnEsc = false,
  closeOnBlur = false,
  onClose,
  cardClassName,
  show = false,
  ...props
}: ModalProps) {
  const titleId = useId();

  return (
    <BulmaModal
      {...props}
      show={true}
      showClose={false}
      onClose={onClose}
      closeOnBlur={closeOnBlur}
      closeOnEsc={closeOnEsc}
      className={show ? styles.visible : styles.hidden}
    >
      <BulmaModal.Card
        className={cardClassName}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <BulmaModal.Card.Body
          p={9}
          className={styles.bodyContainer}
          display="flex"
          flexDirection="column"
        >
          <Element
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Element>
              <h1
                id={titleId}
                className={`has-text-weight-light is-size-4 ${titleClassName}`}
              >
                {title}
              </h1>
            </Element>
            <If condition={showClose}>
              <Element
                display="flex"
                justifyContent="flex-end"
                className="is-align-self-flex-start"
              >
                <Button
                  className="is-borderless is-narrow is-paddingless h-fit-content"
                  onClick={onClose}
                  aria-label="Close"
                  justifyContent="flex-end"
                >
                  <Icon color={'primary-dark'}>
                    <FaXmark />
                  </Icon>
                </Button>
              </Element>
            </If>
          </Element>
          <Element>{children}</Element>
        </BulmaModal.Card.Body>
      </BulmaModal.Card>
    </BulmaModal>
  );
}

export default Modal;
